document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchFacetParamsOptions", function (params, facet) {
    if (facet.escapedName === "vendor" || facet.escapedName === "inventory_available") {
      return {
        ...params,
        showMore: true,
        limit: 7,
        searchablePlaceholder: "Search",
        transformItems(items) {
          const facetSelector = `.ais-facet-${facet.escapedName}`;

          const facetElement = document.querySelector(facetSelector);
          if (facetElement) facetElement.style.display = items.length <= 1 ? "none" : "";
          return items;
        },
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            // Customize the display for 'inventory_available' facet
            if (facet.escapedName === "inventory_available") {
              const displayLabel = label === "true" ? "Available Now" : "On Hold/Sold";
              return html`
                <label class="ais-RefinementList-label fp-font-weight--regular">
                  <input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" />
                  <span class="ais-RefinementList-labelText">${displayLabel}</span>
                  <span class="ais-RefinementList-count">(${count})</span>
                </label>
              `;
            } else {
              // Default rendering for other facets (if any)
              return html`
                <label class="ais-RefinementList-label fp-font-weight--regular">
                  <input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" />
                  <span class="ais-RefinementList-labelText">${label}</span>
                  <span class="ais-RefinementList-count">(${count})</span>
                </label>
              `;
            }
          },
        },
      };
    }

    if (facet.escapedName.includes("condition")) {
      return {
        ...params,
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            return html`
              <label class="ais-RefinementList-label fp-font-weight--regular"
                ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                  class="ais-RefinementList-labelText"
                  >${label}</span
                ><span class="ais-RefinementList-count">(${count})</span></label
              >
            `;
          },
        },
      };
    }

    if (facet.escapedName === "hold_status") {
      return {
        ...params,
        showMore: true,
        limit: 7,
        transformItems(items) {
          if (items.length > 1 && window.location.pathname === "/pages/following") {
            return items;
          } else {
            return [];
          }
        },
        templates: {
          item(item, { html }) {
            const { label, count } = item;
            return html`
              <label class="ais-RefinementList-label fp-font-weight--regular"
                ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                  class="ais-RefinementList-labelText"
                  >${label}</span
                ><span class="ais-RefinementList-count">(${count})</span></label
              >
            `;
          },
        },
      };
    }

    return {
      ...params,
      showMore: true,
      limit: 7,
      templates: {
        item(item, { html }) {
          const { label, count } = item;
          return html`
            <label class="ais-RefinementList-label fp-font-weight--regular"
              ><input class="ais-RefinementList-checkbox" type="checkbox" value="${label}" /><span
                class="ais-RefinementList-labelText"
                >${label}</span
              ><span class="ais-RefinementList-count">(${count})</span></label
            >
          `;
        },
      },
    };
  });
});
